import { render, staticRenderFns } from "./UserListActivities.vue?vue&type=template&id=0d8bb06c&scoped=true&xmlns%3Ab-row=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&"
import script from "./UserListActivities.vue?vue&type=script&lang=js&"
export * from "./UserListActivities.vue?vue&type=script&lang=js&"
import style0 from "./UserListActivities.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./UserListActivities.vue?vue&type=style&index=1&id=0d8bb06c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8bb06c",
  null
  
)

export default component.exports